import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import Filters from "./Filters-search";
import ResultFilters from "./Result-filter";
import ResultProperties from "./Result-properties";
import Ownersresults from "./Owners-filter";
import MobileAdvance from "./Mobile-advance";
import { fetchExportOptions } from "../../../helpers/propertyExports";
import http from "../../../helpers/http";
import * as helpers from "../../../helpers/helpers";
import { toast } from "react-toastify";
import {
  DEFAULT_EXPORT_MAX_PROPERTIES,
  mergePropertyIds,
} from "./propertySelection";
import { requestBulkPropertyIds } from "./bulkPropertySelection";

const getStoredSearchRequest = () => {
  try {
    const request = JSON.parse(localStorage.getItem("currentFilters"));
    return request && typeof request === "object" && !Array.isArray(request)
      ? request
      : null;
  } catch {
    return null;
  }
};

const ResultSearch = (data) => {
  const hideSearch = data?.hideSearch;
  const ToggleHideSearch = data?.ToggleHideSearch;
  const searchedPage = data?.searchedPage;
  const sortValue = data?.sortValue;
  const setSortValue = data?.setSortValue;
  const [listingData, setListingData] = useState(null);

  const [exportMaxProperties, setExportMaxProperties] = useState(
    DEFAULT_EXPORT_MAX_PROPERTIES
  );
  const [selectedPropertyIds, setSelectedPropertyIds] = useState([]);
  const selectedPropertyIdsRef = useRef([]);
  // The parent passes the search it last ran. Without one (e.g. /search-result)
  // the stored filters are re-read on every use, never cached at mount, so a
  // later search or re-sort is never answered with the first search's results.
  const activeSearchRequest = data?.activeSearchRequest || null;
  const activeSearchRequestRef = useRef(activeSearchRequest);
  const currentSearchRequest = () =>
    activeSearchRequestRef.current || getStoredSearchRequest();
  const [isBulkSelecting, setIsBulkSelecting] = useState(false);
  const [newAddedPropertyLabels, setNewAddedPropertyLabels] = useState([]);
  const [showowners, setShowowners] = useState(true);
  const ownertoggle = () => {
    setShowowners(!showowners);
  };

  useEffect(() => {
    setListingData([]);
    if (data.data) {
      setListingData(JSON.parse(data.data));
    }
  }, [data.data]);

  // Layout, not passive: a bulk response resolving right after a new search
  // commits must already see that search, or `isCurrent` accepts stale IDs.
  useLayoutEffect(() => {
    activeSearchRequestRef.current = activeSearchRequest;
  }, [activeSearchRequest]);

  useEffect(() => {
    fetchExportOptions()
      .then((options) => {
        if (Number.isInteger(options?.max_properties) && options.max_properties > 0) {
          setExportMaxProperties(options.max_properties);
        }
      })
      .catch(() => {});
  }, []);
  const getPropertyTitles = (propertyData, selectedPropertyIds) => {
    if (propertyData?.length > 0) {
      const propertyTitles = propertyData
        ?.filter((property) => selectedPropertyIds.includes(property.fips_apn))
        .map((property) => property.title);
      return propertyTitles;
    }
  };

  // selectedPropertyIds already contains all IDs across all pages,
  // so we return the full list directly instead of filtering only the current page.
  const selectedPropertyTitles = getPropertyTitles(
    listingData?.properties,
    selectedPropertyIds
  );
  const selectedPropertyParcelIDs = selectedPropertyIds;
  // const [hideSearch, setHideSearch] = useState(false);
  // const ToggleHideSearch = () => {
  //   setHideSearch(!hideSearch);
  // };
  const handleSearchSortSubmit = (e, value) => {
    data?.handleSubmit(e, value);
  };

  useEffect(() => {
    selectedPropertyIdsRef.current = selectedPropertyIds;
  }, [selectedPropertyIds]);

  const updateSelectedPropertyIds = setSelectedPropertyIds;

  const handleBulkSelectPages = async (pages) => {
    const activeSearch = currentSearchRequest();

    if (!activeSearch) {
      toast.error("Run a property search before selecting multiple pages.");
      return;
    }

    setIsBulkSelecting(true);

    try {
      const result = await requestBulkPropertyIds({
        activeSearch,
        pages,
        post: (payload) => http.post(
          "/search-data",
          helpers.doObjToFormData(payload)
        ),
        isCurrent: (snapshot) =>
          JSON.stringify(currentSearchRequest()) === JSON.stringify(snapshot),
      });

      if (result.stale) {
        return;
      }

      const selection = mergePropertyIds(
        selectedPropertyIdsRef.current,
        result.propertyIds,
        exportMaxProperties
      );

      updateSelectedPropertyIds(selection.ids);

      if (selection.capped) {
        toast.warn(
          `Added ${selection.addedCount.toLocaleString()} properties and reached the ${exportMaxProperties.toLocaleString()} property export limit.`
        );
      } else {
        toast.success(
          `Added ${selection.addedCount.toLocaleString()} properties from the first ${pages} ${pages === 1 ? "page" : "pages"}.`
        );
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Unable to select properties from this search. Please try again."
      );
    } finally {
      setIsBulkSelecting(false);
    }
  };

  return (
    <>
      {/* <MobileAdvance />
      <Filters
        ToggleHideSearch={ToggleHideSearch}
        hideSearch={hideSearch}
        ownertoggle={ownertoggle}
        showowners={showowners}
      /> */}
      {/* <h1></h1> */}
      <ResultFilters
        showowners={showowners}
        ownertoggle={ownertoggle}
        ToggleHideSearch={ToggleHideSearch}
        hideSearch={hideSearch}
        toggleResultView={data.toggleResultView}
        resultView={data.resultView}
        sortValue={sortValue}
        setSortValue={setSortValue}
        handleSearchSortSubmit={handleSearchSortSubmit}
        selectedPropertyIds={selectedPropertyIds}
        exportMaxProperties={exportMaxProperties}
        selectedPropertyTitles={selectedPropertyTitles}
        setNewAddedPropertyLabels={setNewAddedPropertyLabels}
        newAddedPropertyLabels={newAddedPropertyLabels}
        selectedPropertyParcelIDs={selectedPropertyParcelIDs}
        onBulkSelectPages={handleBulkSelectPages}
        isBulkSelecting={isBulkSelecting}
        bulkSelectionDisabled={!currentSearchRequest()}
      />
      {listingData && !showowners && (
        <Ownersresults
          data={listingData}
          showowners={showowners}
          ownertoggle={ownertoggle}
          ToggleHideSearch={ToggleHideSearch}
          hideSearch={hideSearch}
        />
      )}
      {listingData && showowners && (
        <ResultProperties
          data={listingData}
          handlePageClick={data.handlePageClick}
          hideSearch={hideSearch}
          searchedPage={searchedPage}
          drawnFeatures={data.drawnFeatures}
          setDrawnFeatures={data.setDrawnFeatures}
          setSelectedPropertyIds={updateSelectedPropertyIds}
          selectedPropertyIds={selectedPropertyIds}
          exportMaxProperties={exportMaxProperties}
          newAddedPropertyLabels={newAddedPropertyLabels}
          setShowowners={setShowowners}
          setListingData={setListingData}
          Maptoggle={data.Maptoggle}
          setSearchQueryValues={data.setSearchQueryValues}
          handleSubmit={data.handleSubmit}
          propertyTypeExists={data?.propertyTypeExists}
        />
      )}
    </>
  );
};

export default ResultSearch;
